// "scheduler.<key>" 로 부르는 문구. 값에 {name} 을 두면 t(key, { name }) 로 채운다.
// schedule.* = SchedulerPanel(주간 반복 예약), section.* = SectionPanel(셀 묶음 저장).
const scheduler = {
  ko: {
    // 요일 약칭. 예약 행·요일 토글·다음 실행 시각 표기에 같이 쓴다.
    "schedule.day.SUN": "일",
    "schedule.day.MON": "월",
    "schedule.day.TUE": "화",
    "schedule.day.WED": "수",
    "schedule.day.THU": "목",
    "schedule.day.FRI": "금",
    "schedule.day.SAT": "토",
    "schedule.nextRun.format": "{month}/{day} ({weekday}) {time}",

    "schedule.title": "예약 비행",
    "schedule.helpAria": "예약 비행 도움말",
    "schedule.helpTip":
      "요일과 시각을 정해 두면 드론이 자동으로 비행합니다. 구역을 고르지 않으면 전체 셀을 비행합니다. 같은 요일·시각의 예약은 하나만 둘 수 있습니다.",
    "schedule.empty": "예약이 없습니다. 아래에서 요일과 시각을 골라 추가하세요.",

    "schedule.row.switchOn": "예약 켜기",
    "schedule.row.switchOff": "예약 끄기",
    "schedule.row.edit": "이 예약 수정",
    "schedule.row.allCells": "전체 셀",
    "schedule.row.next": "다음 {next}",
    "schedule.row.off": "꺼짐",
    "schedule.row.lastFailed": " · 최근 실패 {error}",
    "schedule.row.delete": "예약 삭제",

    "schedule.form.editTitle": "예약 수정 · {time}",
    "schedule.form.newTitle": "새 예약",
    "schedule.form.resetToNew": "새 예약으로",
    "schedule.form.hour": "시",
    "schedule.form.minute": "분",
    "schedule.form.section": "비행 구역",
    "schedule.form.allCellsDefault": "전체 셀 (기본)",
    "schedule.form.sectionOption": "{name} · {count}셀",
    "schedule.form.saveEdit": "수정 저장",
    "schedule.form.add": "예약 추가",

    "schedule.toast.needTarget": "농장과 드론이 선택돼야 합니다.",
    "schedule.toast.needDays": "요일을 하나 이상 고르세요.",
    "schedule.toast.updated": "예약을 수정했습니다.",
    "schedule.toast.created": "예약을 추가했습니다.",
    "schedule.toast.saveFailed": "예약을 저장하지 못했습니다.",
    "schedule.toast.toggleFailed": "예약 상태를 바꾸지 못했습니다.",
    "schedule.toast.deleteFailed": "예약을 삭제하지 못했습니다.",

    // 데모 전용. 예약 발화를 브라우저가 대신하므로 그 사실과 한계를 화면에도 적는다.
    "schedule.demo.fired": "예약 비행을 시작합니다 — {name} · {count}칸 (약 {minutes}분)",
    "schedule.demo.skippedBusy": "예약 시각이 됐지만 이미 비행 중이라 건너뜁니다.",
    "schedule.demo.allCells": "전체 칸",
    "schedule.demo.notice": "이 화면이 열려 있는 동안에만 예약이 실행됩니다.",
    "schedule.confirm.delete": "이 예약을 삭제할까요?",
    "schedule.error.duplicate": "같은 요일·시각의 예약이 이미 있습니다. 시각이나 요일을 바꾸세요.",
    "schedule.error.sectionMissing": "선택한 섹션이 없습니다. 목록을 새로고침하세요.",

    "section.title": "섹션",
    "section.helpAria": "섹션 도움말",
    "section.helpTip": "지도에서 고른 셀을 이름을 붙여 저장합니다. 미션 박스의 불러오기와 예약의 구역 선택에서 같이 씁니다.",
    "section.empty": "저장된 섹션이 없습니다. 지도에서 셀을 고르고 아래에서 저장하세요.",

    "section.row.summary": "셀 {count}개 · {altitude}m",
    "section.row.usedBy": " · 예약 {count}건 사용",
    "section.row.rename": "이름 변경",
    "section.row.delete": "삭제",

    "section.form.namePlaceholder": "섹션 이름 (예: 북쪽 두 줄)",
    "section.form.altitude": "비행 고도(m)",
    "section.form.saveSelected": "지금 선택 {count}개 셀을 섹션으로 저장",
    "section.form.saveDisabled": "지도에서 셀을 고르면 저장할 수 있습니다",

    "section.toast.nameRequired": "섹션 이름을 입력하세요.",
    "section.toast.altitudeRange": "고도는 {min}~{max}m 사이여야 합니다.",
    "section.toast.cellsRequired": "지도에서 셀을 먼저 고르세요.",
    "section.toast.saved": '"{name}" 저장됨 · 셀 {count}개',
    "section.toast.duplicateName": "같은 이름의 섹션이 이미 있습니다.",
    "section.toast.saveFailed": "섹션을 저장하지 못했습니다.",
    "section.toast.renameFailed": "이름을 바꾸지 못했습니다.",
    "section.toast.deleteInUse": "예약에서 사용 중인 섹션은 삭제할 수 없습니다.",
    "section.toast.deleteFailed": "섹션을 삭제하지 못했습니다.",
    "section.prompt.rename": "섹션 이름",
    "section.confirm.delete": '"{name}" 섹션을 삭제할까요?',
    "section.deleteBlocked": ({ name, count }) =>
      `"${name}" 은(는) 예약 ${count}건에서 쓰고 있어 삭제할 수 없습니다. 예약의 구역을 먼저 바꾸세요.`,
  },
  en: {
    "schedule.day.SUN": "Sun",
    "schedule.day.MON": "Mon",
    "schedule.day.TUE": "Tue",
    "schedule.day.WED": "Wed",
    "schedule.day.THU": "Thu",
    "schedule.day.FRI": "Fri",
    "schedule.day.SAT": "Sat",
    "schedule.nextRun.format": "{month}/{day} ({weekday}) {time}",

    "schedule.title": "Scheduler",
    "schedule.helpAria": "Scheduler help",
    "schedule.helpTip":
      "Pick days and a time and the drone flies automatically. If no section is chosen, it flies all cells. Only one schedule is allowed per day and time.",
    "schedule.empty": "No schedules yet. Pick days and a time below to add one.",

    "schedule.row.switchOn": "Enable schedule",
    "schedule.row.switchOff": "Disable schedule",
    "schedule.row.edit": "Edit this schedule",
    "schedule.row.allCells": "All cells",
    "schedule.row.next": "Next {next}",
    "schedule.row.off": "Off",
    "schedule.row.lastFailed": " · Last failure: {error}",
    "schedule.row.delete": "Delete schedule",

    "schedule.form.editTitle": "Edit schedule · {time}",
    "schedule.form.newTitle": "New schedule",
    "schedule.form.resetToNew": "Start new",
    "schedule.form.hour": "Hour",
    "schedule.form.minute": "Minute",
    "schedule.form.section": "Flight section",
    "schedule.form.allCellsDefault": "All cells (default)",
    "schedule.form.sectionOption": ({ name, count }) => `${name} · ${count} ${count === 1 ? "cell" : "cells"}`,
    "schedule.form.saveEdit": "Save changes",
    "schedule.form.add": "Add schedule",

    "schedule.toast.needTarget": "Please select a farm and a drone first.",
    "schedule.toast.needDays": "Please select at least one day.",
    "schedule.toast.updated": "Schedule updated.",
    "schedule.toast.created": "Schedule added.",
    "schedule.toast.saveFailed": "Failed to save the schedule.",
    "schedule.toast.toggleFailed": "Failed to change the schedule status.",
    "schedule.toast.deleteFailed": "Failed to delete the schedule.",

    "schedule.demo.fired": "Starting the scheduled flight — {name} · {count} cells (about {minutes} min)",
    "schedule.demo.skippedBusy": "The scheduled time arrived, but a flight is already running. Skipped.",
    "schedule.demo.allCells": "All cells",
    "schedule.demo.notice": "Schedules run only while this screen stays open.",
    "schedule.confirm.delete": "Delete this schedule?",
    "schedule.error.duplicate": "A schedule with the same day and time already exists. Change the time or day.",
    "schedule.error.sectionMissing": "The selected section no longer exists. Refresh the list.",

    "section.title": "Sections",
    "section.helpAria": "Sections help",
    "section.helpTip":
      "Save the cells selected on the map under a name. Used by Load in the mission box and by the section picker in schedules.",
    "section.empty": "No saved sections. Select cells on the map and save them below.",

    "section.row.summary": ({ count, altitude }) => `${count} ${count === 1 ? "cell" : "cells"} · ${altitude}m`,
    "section.row.usedBy": ({ count }) => ` · Used by ${count} ${count === 1 ? "schedule" : "schedules"}`,
    "section.row.rename": "Rename",
    "section.row.delete": "Delete",

    "section.form.namePlaceholder": "Section name (e.g. North two rows)",
    "section.form.altitude": "Flight altitude (m)",
    "section.form.saveSelected": ({ count }) => `Save ${count} selected ${count === 1 ? "cell" : "cells"} as a section`,
    "section.form.saveDisabled": "Select cells on the map to save",

    "section.toast.nameRequired": "Please enter a section name.",
    "section.toast.altitudeRange": "Altitude must be between {min} and {max}m.",
    "section.toast.cellsRequired": "Please select cells on the map first.",
    "section.toast.saved": ({ name, count }) => `"${name}" saved · ${count} ${count === 1 ? "cell" : "cells"}`,
    "section.toast.duplicateName": "A section with the same name already exists.",
    "section.toast.saveFailed": "Failed to save the section.",
    "section.toast.renameFailed": "Failed to rename the section.",
    "section.toast.deleteInUse": "A section used by a schedule cannot be deleted.",
    "section.toast.deleteFailed": "Failed to delete the section.",
    "section.prompt.rename": "Section name",
    "section.confirm.delete": 'Delete section "{name}"?',
    "section.deleteBlocked": ({ name, count }) =>
      `"${name}" is used by ${count} ${count === 1 ? "schedule" : "schedules"} and cannot be deleted. Change the section on those schedules first.`,
  },
};

export default scheduler;
